// extracted by mini-css-extract-plugin
export var canvasWrapper = "styles-module--canvasWrapper--4a546";
export var error = "styles-module--error--2236e";
export var loading = "styles-module--loading--fa9a1";
export var section = "styles-module--section--43ceb";
export var spinner = "styles-module--spinner--a245b";
export var text = "styles-module--text--ced02";